import { cn } from '@/lib/utils';
import type { Game } from '@/types/game';

export interface GameSurfaceProps {
  game: Game;
  surfaceType: 'preview' | 'info';
  className?: string;
  style?: React.CSSProperties;
  title?: string;
}

// IS-INV-040: URL constructed from game.frontendUrl convention only — no config keys, no hardcoded URLs.
// IS-INV-008: Sandbox exactly as specified — no allow-top-navigation, no additions.
// IS-INV-001: No addEventListener('message') — this is a pure display surface with no postMessage protocol.
export function GameSurface({ game, surfaceType, className, style, title }: GameSurfaceProps) {
  const src = `${game.frontendUrl}/public/${surfaceType}`;

  return (
    <iframe
      src={src}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
      title={title ?? `${game.displayName} ${surfaceType}`}
      loading="lazy"
      className={cn('h-[220px] w-full border-0', className)}
      style={style}
    />
  );
}
